import * as React from 'react';

const checkIcon = (props) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m8 12.395 3 3 5-6"
      stroke="#0050B4"
      strokeWidth={3.333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 21.895c5.523 0 10-4.478 10-10 0-5.523-4.477-10-10-10s-10 4.477-10 10c0 5.522 4.477 10 10 10Z"
      stroke="#0050B4"
      strokeWidth={3.333}
    />
  </svg>
);

export default checkIcon;
